import { Input } from '@/components/uiKit/FormControl';
import React from 'react';
import { Controller } from 'react-hook-form';

const inputClasses = 'min-w-[390px]';

export const InputField = ({
  name,
  label,
  disabled = true,
  classNames,
  control,
  dataTestId
}: {
  name: string;
  label: string;
  disabled?: boolean;
  classNames?: { input?: string };
  control: any;
  dataTestId?: string;
}) => (
  <Controller
    name={name}
    control={control}
    render={({ field }) => (
      <Input
        {...field}
        classNames={classNames}
        disabled={name !== 'component' && name !== 'comments'}
        label={label}
        value={field.value} // Ensure it controls the label's floating behavior properly ()
        dataTestId={dataTestId}
      />
    )}
  />
);
